import { AppWindow, LayoutDashboard, LogIn, ScrollText, ShieldCheck, UserRound } from "lucide-react";

// The Applications product: AuthNull signs users in to the tenant's own apps
// (OpenID Connect, SAML) or gives them a second factor (MFA API).
const mfaApplicationsNavigation = [
  {
    key: "/pam/applications/dashboard",
    icon: <LayoutDashboard className="icon" />,
    label: "Dashboard",
    navigate: "/pam/applications/dashboard",
  },
  {
    key: "/pam/applications",
    icon: <AppWindow className="icon" />,
    label: "Applications",
    navigate: "/pam/applications",
  },
  {
    // The directory users that app assignments and policies are built from,
    // with their MFA set-up (the same screen as Identity and RADIUS).
    key: "/pam/users",
    icon: <UserRound className="icon" />,
    label: "Users",
    navigate: "/pam/users",
  },
  {
    // App policies (the shared policy screens): who may use an MFA API app,
    // and who approves the push.
    key: "/pam/policies/apps",
    icon: <ScrollText className="icon" />,
    label: "Policies",
    navigate: "/pam/policies/apps",
  },
  {
    key: "/pam/applications/signInSource",
    icon: <LogIn className="icon" />,
    label: "Sign-in source",
    navigate: "/pam/applications/signInSource",
  },
  {
    // The shared logs screen; AuthLogsIndex limits it to oidc / saml / mfa_api.
    key: "/pam/auth-logs",
    icon: <ShieldCheck className="icon" />,
    label: "Sign-in logs",
    navigate: "/pam/auth-logs",
  },
];

export default mfaApplicationsNavigation;
